import { FC } from "react";
import { StyleProp, StyleSheet, View, ViewStyle } from "react-native";
import { kStyleConst } from "src/kStyle";

const Spacer: FC<{ width?: string | number; spacerStyle?: StyleProp<ViewStyle> }> = ({
  spacerStyle = {},
  width = 20,
}) => <View style={[styles.P09_Spacer, spacerStyle, { width }]} />;

export default Spacer;

const styles = StyleSheet.create({
  P09_Spacer: {
    width: 4 * kStyleConst.kSpacing,
  },
});
